import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import DatePicker from 'react-bootstrap-date-picker';
import InputMask from 'react-input-mask';

class TeamTasksAcoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      name: this.props.tarefa,
      date: this.props.date,
      team_task_id: this.props.team_task_id,
      status: this.props.status,
      class_status: '',
      alt_status: '',
      title_status: '',
      class_disabled: false,
      modal: false,
      dados: [],
      lista_instrutores: [],
    };
    this.showModal = this.showModal.bind(this);
    this.editarTarefa = this.editarTarefa.bind(this);
    this.trocarStatus = this.trocarStatus.bind(this);
    this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
  }

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDatePicker(value, formattedValue) {
    this.setState({
      date: value,
      date_str: formattedValue,
    });
  }
  componentDidMount () {
    if (this.state.status == 'aberta') {
      this.setState({class_status: 'btn btn-sm btn-success'});
      this.setState({alt_status: 'Trocar para concluida'});
      this.setState({title_status: 'Trocar para concluida'});
    } else {
      this.setState({class_status: 'btn btn-sm btn-warning'});
      this.setState({alt_status: 'Concluida'});
      this.setState({title_status: 'Concluida'});
      this.setState({class_disabled: 'disabled'});
    }
  }

  showModal(event) {
    this.setState({dados:[]})
    this.setState({ modal: true });
  }

  // Fetch salvando a edição
  editarTarefa(event) {
    event.preventDefault();
    var datasave = {
      id: this.state.team_task_id,
      date: this.state.date_str,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/tarefa', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  trocarStatus (event) {
    event.preventDefault();
    var toggle = this.state.status;
    if (toggle === 'aberta') {
      toggle = 'concluida';
    } else if (toggle === 'concluida') {
      toggle = 'aberta';
    }
    var datasave = {
      id: this.state.team_task_id,
      status: toggle,
    };
    var confirmacao = window.confirm('Tem certeza que deseja mudar o status dessa tarefa?');
    if(confirmacao) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/tarefa/change_status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if (toggle === 'concluida') {
              self.setState({class_status: 'btn btn-sm btn-warning'});
              self.setState({alt_status: 'Concluida'});
              self.setState({title_status: 'Concluida'});
              self.setState({status: toggle});
              self.setState({class_disabled: 'disabled'});
            }
          }
          self.props.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className='btn-group'>
    <button onClick={this.trocarStatus} disabled={this.state.class_disabled} className={this.state.class_status} alt={this.state.alt_status} title={this.state.title_status}><i className="fa fa-fw fa-check"></i></button>
    <button onClick={this.showModal} className='btn btn-sm btn-primary' alt='Editar' title='Editar'><i className="fa fa-fw fa-pencil"></i></button>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Editar tarefa - {this.state.tarefa}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.editarTarefa}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" className="form-control" placeholder="Seu nome" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data prevista:</label>
              <DatePicker onChange={this.handleChangeDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data prevista" value={this.state.date} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Salvar</button>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default TeamTasksAcoes;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTasksAcoes.js